<template>
  <div class="card-visit">
    <div
      v-if="isVisitToday"
      class="card-visit__label card-visit__label--today"
    >
      <span>{{ trans('deal_dashboard.card.visit.today') }}</span>
    </div>
    <div
      v-else-if="isVisitPassed"
      class="card-visit__label card-visit__label--passed"
    >
      <span>{{ trans('deal_dashboard.card.visit.passed') }}</span>
    </div>
    <div
      v-else-if="isVisitAfterToday"
      class="card-visit__label card-visit__label--scheduled"
    >
      <span>{{ trans('deal_dashboard.card.visit.scheduled') }}</span>
    </div>
    <div class="card-visit__date">
      {{ formatDate }}
    </div>
  </div>
</template>

<script>
import translation from '@elements/translation';
import {
  getShorterReadableDate,
  getReadableTime,
  isSameDay,
  isDateInFuture,
  isDateInPast,
  setToEndOfDay,
} from '@tools/date';

export default {
  name: 'CardVisit',
  mixins: [ translation ],
  props: {
    visit: { type: Object, required: true },
  },
  data() {
    return {};
  },
  computed: {
    isVisitPassed() {
      return isDateInPast(this.visit.iso);
    },
    isVisitToday() {
      return isSameDay(this.visit.iso);
    },
    isVisitAfterToday() {
      return isDateInFuture(this.visit.iso, setToEndOfDay());
    },
    formatDate() {
      const time = this.visit.iso.indexOf('00:00:00') === -1
        ? ` • ${getReadableTime(this.visit.iso)}` : '';
      return `${getShorterReadableDate(this.visit.iso)}${time}`;
    },
  },
};
</script>
